"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Dashboard = _interopRequireDefault(require("@rsuite/icon-font/lib/application/Dashboard"));

// Generated by script, don't edit it please.
var Dashboard = (0, _createSvgIcon["default"])({
  as: _Dashboard["default"],
  ariaLabel: 'dashboard',
  category: 'application',
  displayName: 'Dashboard'
});
var _default = Dashboard;
exports["default"] = _default;
module.exports = exports.default;